import { useRouter } from "next/router";
import { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { updateProductCategory } from "@redux/action/productFiltersAction";

const CategorySection = styled.section`
  display: flex;
  width: 100%;
`;

const CategoryListWrapper = styled.div`
  flex: 1;
  height: 354px;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #ffffff;
  padding: 20px 0;
  border-radius: 0 0 8px 8px;
`;

const CategoryList = styled.ul`
  display: grid;
  grid-template-columns: repeat(8, 1fr); //  8개 고정
  width: 100%;
  max-width: 1110px;
  padding: 0 10px;
`;

const CategorySelect = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const MenuButton = styled.button`
  width: 170px;
  padding: 67px 20px;
  border: none;
  background-color: ${({ $active }) => ($active ? "#ffffff" : "#f3f3f3")};
  color: ${({ $active }) => ($active ? "#3bb77e" : "#7b7b7b")};
  font-weight: ${({ $active }) => ($active ? "700" : "500")};
  text-align: start;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 16px;
  line-height: 1.4;

  &:hover {
    background-color: #ffffff;
    color: #3bb77e;
  }

  /* 상단 버튼 */
  &:first-child {
    border-radius: 0;
  }

  /* 하단 버튼 (좌측 하단 둥글게) */
  &:last-child {
    border-bottom-left-radius: 8px;
  }
`;

const Category = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: color 0.2s;
  font-size: 16px;
  color: #666;
  text-align: center;
  word-break: keep-all;
  margin-bottom: 10px;

  &:nth-child(n + 17) {
    margin-bottom: 0;
  }

  .image-box {
    width: 60%;
    height: 65px;
    background: #f4f4f4;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 12px;
    margin-bottom: 6px;
    cursor: pointer;
    img {
      object-fit: contain;
      max-width: 100%;
      max-height: 100%;
    }
  }

  .name {
    font-size: 15px;
    text-align: center;
    line-height: 1.4;
    transition: color 0.2s;
    margin-bottom: 6px;
  }

  .name.active {
    color: #3bb77e;
  }

  &:hover .name {
    color: #3bb77e;
    cursor: pointer;
  }

  &.active .name {
    color: #3bb77e;
  }

  &.active .image-box {
    border: 2px solid #3bb77e;
    background: #ffffff;
  }
`;

const CategoryProductMenu = ({
  setToggled,
  categoriRef,
  dummyList,
  updateProductCategory,
}) => {
  const router = useRouter();
  const currentEname = router.query.slug;
  const [category, setCategory] = useState([]);
  const [categoryType, setCategoryType] = useState("S");

  const selectCategory = (e, category) => {
    if (category.code === router.query.code) return;
    e.preventDefault();
    router.push(`/products/${category.ename}/`);
    // categoriRef.current.children[1].style.display = "none";
    // categoriRef.current.children[1].style.zIndex = -1;
  };

  const handleCategoryType = (type) => {
    setCategoryType(type);
    fetchCategory(type);
  };

  const fetchCategory = async () => {
    const filtered = dummyList.category?.filter((el) =>
      categoryType === "T" ? el.division === "T" : el.division === "S"
    );
    updateProductCategory(filtered);
    setCategory(filtered);
  };

  // 저장된 categoryType 불러오기
  useEffect(() => {
    const savedType = localStorage.getItem("categoryType");
    if (savedType === "S" || savedType === "T") {
      setCategoryType(savedType);
    }
  }, []);

  // categoryType이 변경될 때 저장
  useEffect(() => {
    localStorage.setItem("categoryType", categoryType);
    if (dummyList.category) {
      fetchCategory();
    }
  }, [categoryType, dummyList]);

  return (
    <CategorySection>
      <CategorySelect>
        <MenuButton
          $active={categoryType === "S"}
          $type="S"
          onClick={() => handleCategoryType("S")}
        >
          포장재
          <br />
          먼저 선택하기 &gt;
        </MenuButton>
        <MenuButton
          $active={categoryType === "T"}
          $type="T"
          onClick={() => handleCategoryType("T")}
        >
          포장할 상품
          <br />
          먼저 선택하기 &gt;
        </MenuButton>
      </CategorySelect>

      <CategoryListWrapper>
        <CategoryList>
          {category?.map((item, i) => (
            <Category
              onClick={(e) => selectCategory(e, item)}
              key={i}
              className={item.ename === currentEname ? "active" : ""}
            >
              <div className="image-box">
                <img src={item.image} alt={item.name} />
              </div>
              <div
                className={`name ${
                  item.ename === currentEname ? "active" : ""
                }`}
              >
                {item.name}
              </div>
            </Category>
          ))}
        </CategoryList>
      </CategoryListWrapper>
    </CategorySection>
  );
};
const mapStateToProps = (state) => ({
  dummyList: state.dummyList,
});

const mapDidpatchToProps = {
  updateProductCategory,
};

export default connect(
  mapStateToProps,
  mapDidpatchToProps
)(CategoryProductMenu);
